import { Image } from '@jfs/ui-new'
import React, { useEffect, useState } from 'react'
import { Animated } from 'react-native'

export const PayAnyOneAnyWhereAnimation = ({
  width,
  height,
  src,
  animationWidth,
  expandAnimation,
  collapseAnimation,
}: any) => {
  const [animatedValue] = useState<any>(new Animated.Value(0))
  const animate = {
    transform: [
      {
        translateX: animatedValue.interpolate({
          inputRange: [0, 1],
          outputRange: [animationWidth, 0],
        }),
      },
    ],
  }

  const startAnimation = () => {
    Animated.timing(animatedValue, {
      toValue: expandAnimation ? 1 : 0,
      duration: 1000,
      useNativeDriver: true,
    }).start()
  }

  useEffect(() => {
    if (expandAnimation || collapseAnimation) {
      startAnimation()
    }
  }, [expandAnimation, collapseAnimation, startAnimation])
  return (
    <Animated.View style={[animate, { width: width, height: height }]}>
      <Image source={src} width={width} height={height} />
    </Animated.View>
  )
}
